// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__gGEZ4","mainContainer":"NotFound_mainContainer__uTZ2k","title":"NotFound_title__7zDPZ"};